"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var ToastRegion_component_exports = {};
__export(ToastRegion_component_exports, {
  ToastRegion: () => ToastRegion
});
module.exports = __toCommonJS(ToastRegion_component_exports);
var import_jsx_runtime = require("react/jsx-runtime");
var import_react = require("react");
var import_ToastContext = require("./ToastContext.component");
var import_toast = require("@react-aria/toast");
var import_Toast = require("./Toast.component");
function ToastRegion() {
  let state = (0, import_react.useContext)(import_ToastContext.ToastContext);
  let ref = (0, import_react.useRef)(void 0);
  let { regionProps } = (0, import_toast.useToastRegion)({}, state, ref);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)("div", __spreadProps(__spreadValues({}, regionProps), { ref, children: state.visibleToasts.map((toast) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_Toast.Toast, { toast }, toast.key)) }));
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  ToastRegion
});
//# sourceMappingURL=ToastRegion.component.js.map